import "./TransferFilesToLocationModal.scss";
import { useEffect, useState } from "react";
import { Dropdown, Button, Modal } from "antd";
import { LocationDto } from "../../../generated/account-client";
import { DownOutlined } from "@ant-design/icons";
import "../../design/ChangeLocationModal.scss";

export interface TransferFilesToLocationModalProps {
  visible: boolean;
  location: LocationDto;
  locations: LocationDto[];
  onCancel: () => void;
  onTransfer: (location: LocationDto, currentLocation: LocationDto) => void;
}

export default function TransferFilesToLocationModal({
  location,
  locations,
  visible,
  onCancel,
  onTransfer,
}: TransferFilesToLocationModalProps) {
  const [newLocation, setNewLocation] = useState({} as LocationDto);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNewLocation(locations[0]);
    setLoading(false);
  }, [locations]);

  const menu = (
    <div className={"loc-drop-menu change-loc-modal"}>
      <ul>
        {locations.map((it) => (
          <li key={it.id} onClick={() => setNewLocation(it)}>
            <div className={"lk"}>
              <h6>{it.name}</h6>
              <p>
                {it.address} {it.city}
                {it.state !== "" && <span>, {it.state}</span>}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <Modal
      className={"transfer-files-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <header><h2>Transfer {location?.name} files to:</h2></header>

      <Dropdown
        className={"loc-drop change-loc-modal"}
        overlay={menu}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
        trigger={["click"]}
      >
        <Button
          type={"link"}
          size={"large"}
          onClick={(e) => e.preventDefault()}
        >
          {newLocation?.name !== "" && <span>{newLocation?.name}</span>}
          {newLocation?.name === "" && <span>Change Location</span>}
          <DownOutlined className={"carr"} />
        </Button>
      </Dropdown>

      <footer>
        <Button className={"cancel"} size={"large"} onClick={() => onCancel()}>
          <span>Cancel</span>
        </Button>
        <Button
          className={"primary"}
          size={"large"} 
          loading={loading}
          onClick={() => {
            setLoading(true);
            onTransfer(newLocation, location);
          }}
        >
          <span>Transfer Files</span>
        </Button>
      </footer>
    </Modal>
  );
}
